// http://stackoverflow.com/questions/21789749/show-hide-via-bootstraps-collapse-function-divs-based-on-radio-button
$(() => $('input[type="radio"][data-toggle="radio-collapse"]').each((index, item) => {
  const $item = $(item);
  const $target = $($item.data('target'));

  if ($item.is(':checked')) {
    $target.fadeIn();
  } else {
    $target.fadeOut(0);
  }

  $(`input[type="radio"][name="${item.name}"]`).on('change', () => {
    if ($item.is(':checked')) {
      $target.fadeIn();
    } else {
      $target.fadeOut(0);
    }
  });
}));
